<template>
  <div class="busca-simples-api" ref="dropdownSelectBuscaAPi">
    <Input
      type="text"
      class="busca inputSelectBusca"
      readonly
      iconRight="arrow_drop_down"
      :disabled="disabled"
      @click="onClickSelectBusca"
      :label="label"
      v-model="selecionado"
      placeholder="Selecione"
      ref="selectBusca"
      :v="v"
      :params="params"
    />
    <div class="busca-simples-api-lista" v-show="exibe && (!disabled && !readonly)">
      <div>
        <Input
          type="text"
          v-model="busca"
          class="busca-select"
          placeholder="Busca"
          iconRight="search"
          ref="inputBuscaSelect"
          v-debounce:1000ms="handleSearch"
        />
      </div>
      <v-divider></v-divider>
      <div>
        <div class="item" v-if="transicao">{{ this.transicao }}</div>
        <div v-else>
          <div class="item" @click="onClick(null)">{{this.labelNotFound }}</div>
          <div class="item" v-for="item in lista" :key="item.key" @click="onClick(item)">
            <slot :item="item"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "./Input";
import api from "@/api";

export default {
  name: "SelectBuscaApi",
  components: {
    Input
  },
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: ""
    },
    v: Object,
    route: String,
    // minDigisToSearch: {
    //   type: [Number, String],
    //   default: 3
    // },
    params: Object,
    returnDefaultObjectWithNullSelected: Object,
    id: String,
    fieldSearch: String,
    fieldShow: String,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    labelNotFound: {
      type: String,
      default: 'Nenhum'
    }
  },
  data() {
    return {
      busca: "",
      exibe: false,
      lista: [],
      transicao: "",
      selecionado: "",
      clicado: false
    };
  },
  methods: {
    onClickSelectBusca(event) {
      this.exibe = true;
      setTimeout(() => {
        this.$refs.inputBuscaSelect.$refs.input.focus();
      }, 100);
    },
    onClickSelectBuscaAPi(event) {
      const el = this.$refs.dropdownSelectBuscaAPi;
      const target = event.target;
      if (el !== target && !el.contains(target)) {
        this.exibe = false;
      }
    },
    async handleSearch() {
      this.lista = [];
      // if (this.busca.length < this.minDigisToSearch) {
      // if (this.busca.length) {
      //   this.transicao = "";
      //   return;
      // }
      this.transicao = "Buscando...";
      try {
        // const getUrl = this.route.indexOf("?") >= 0 ? "&" : "?";
        // const { data } = await api.get(
        //   `${this.route}${getUrl}${this.fieldSearch}=${this.busca}`
        // ); // &${this.id}=${this.busca}

        const params = {
          ...this.params,
          [this.fieldSearch]: this.busca,
        }


        const { data } = await api.get(
          this.route, {
            params
          }
        ); // &${this.id}=${this.busca}
        this.lista = [];
        if (data.results.length <= 0) {
          this.transicao = "Nenhum encontrado.";
          return;
        }
        for (const key of data.results) {
          this.lista.push({ ...key });
        }
        this.transicao = "";
      } catch (e) {
        this.transicao = "Nenhum encontrado.";
      }
    },
    onClick(dados) {
      let identificador = "";
      this.selecionado = "";

      if (dados) {
        identificador = dados[this.id];
        this.selecionado = dados[this.fieldShow || this.fieldSearch];
      }



      this.busca = "";
      this.exibe = false;
      this.lista = [];
      this.clicado = true;
      this.$emit("input", identificador);

      if(dados === null && this.returnDefaultObjectWithNullSelected) {
        this.$emit("retorno",  this.returnDefaultObjectWithNullSelected);
      } else {
        this.$emit("retorno", dados);
      }

      // if(this.returnDefaultObjectWithNullSelected) {
      //   console.log(this.returnDefaultObjectWithNullSelected)
      //   this.$emit("retorno", dados);
      // } else {
      // }
      this.$refs.selectBusca.$refs.input.focus();
    },
    async buscarItem(valor) {
      try {
        const { data } = await api.get(`${this.route}?${this.id}=${valor}`);
        if (data) {
          this.selecionado =
            data.results[0][this.fieldShow || this.fieldSearch];
        }
      } catch (e) {
        throw e;
        console.log("errorSelectBuscaApi");
      }
    }
  },
  created() {
    document.addEventListener("click", this.onClickSelectBuscaAPi);
    if (this.value) {
      this.buscarItem(this.value);
    }
  },
  destroyed() {
    document.removeEventListener("click", this.onClickSelectBuscaAPi);
  },
  watch: {
    async value(newVal, oldVal) {
      if (this.clicado) {
        this.clicado = false;
        return;
      }
      if (!newVal) {
        this.selecionado = "";
        return;
      }
      this.buscarItem(newVal);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/blocoBusca.scss";

.busca-simples-api {
  .inputSelectBusca {
    .outline-input {
      cursor: pointer;
    }
  }
  .busca-select {
    margin: 10px auto;
    width: 96%;

    .outline-block {
      height: 40px;
      padding: 2px 4px;
    }
  }
}
</style>
